import { SelectionModel } from "@angular/cdk/collections";
import { Component, input, output } from "@angular/core";
import { MatSortModule, Sort } from "@angular/material/sort";
import { AgreementSearchRow } from "../types/AgreementSearchRow";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";

@Component({
  selector: 'agreement-search-results',
  templateUrl: 'agreement-search-results-grid.component.html',
  standalone: true,
  imports: [MatTableModule, CommonModule, MatIconModule, MatSortModule]
})
export class AgreementSearchResultsGridComponent {
  private selection = new SelectionModel<AgreementSearchRow>(false);

  public agreements = input<AgreementSearchRow[]>([]);
  public onEdit = output<AgreementSearchRow>();
  public sortChanged = output<Sort>();

  protected readonly COLUMNS = [
    "VendorName",
    "VendorCode",
    "VendorCountry",
    "AgreementYear",
    "AgreementNumber",
    "AgreementTypeName",
    "AgreementStart",
    "AgreementEnd",
    "PaymentPlan",
    "TimelineDays",
    "AgreementActive"
  ] as const;

  protected doubleClick(row: AgreementSearchRow) {
    if (!this.selection.isSelected(row)) this.selection.toggle(row);

    this.onEdit.emit(row);
  }

  protected onSortChange(evt: Sort) {
    this.sortChanged.emit(evt);
  }
}
